module.exports = __webpack_public_path__ + "static/media/ic_builder_start_line.43bd9348.svg";